<template>
  <aside
    id="sidenav-main"
    class="sidenav navbar navbar-vertical navbar-expand-xs border-0 border-radius-xl my-3 ms-3 bg-white text-dark"
    :class="isRTL ? 'me-3 rotate-caret fixed-end' : 'fixed-start ms-3'"
  >
    <!-- Header du sidebar -->
    <div class="sidenav-header">
      <i
        class="top-0 p-3 cursor-pointer fas fa-times text-secondary opacity-5 position-absolute end-0 d-none d-xl-none"
        aria-hidden="true"
        id="iconSidenav"
      ></i>

      <!-- Redirection vers Profil ou Dashboard -->
      <a
        class="m-0 navbar-brand d-flex align-items-center justify-content-center gap-2"
        :href="redirectToPage"
      >
        <img
          :src="capLogo"
          alt="cap_logo"
          style="height: 30px;"
        />
        <span class="text-logo">Cap Field Partner</span>
      </a>
    </div>

    <hr class="horizontal light mt-0 mb-2" />

    <!-- Liste des liens du sidebar -->
    <sidenav-list />
  </aside>
</template>

<script>
import SidenavList from "./SidenavList.vue";
import capLogo from "@/assets/img/logo-cap.png"; // image logo Cap Field
import { mapState } from "vuex";

export default {
  name: "index",
  components: {
    SidenavList
  },
  data() {
    return {
      capLogo
    };
  },
  computed: {
    ...mapState(["isRTL"]),
    // Vérifie si l'utilisateur est un admin ou un employé et redirige en conséquence
    redirectToPage() {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const role = user?.roles[0]?.toLowerCase();
      // Si l'utilisateur est un employé, redirige vers la page de son profil
      if (role === "employee") {
        return "/employee/profile";  // Redirige vers la page de profil de l'employé
      } else {
        return "/dashboard";  // Redirige vers le dashboard si c'est un admin
      }
    }
  }
};
</script>

<style scoped>
.text-logo {
  color: #333 !important; /* texte noir */
  font-weight: bold;
  font-size: 1rem;
}
</style>
